export default "__VITE_ASSET__SbFMEfRn__"